import { solarHeaderChrome, solarTheme, THEME_ID, TradeSurface } from '@solar/theme-pv';
// Imported from the theme's `./catalogue` subpath rather than its barrel: the grid is a
// client component the storefront renders and never calls, and keeping it off the barrel
// means the server module that assembles this array does not pull the whole block set in
// behind it.
import { SolarListingGrid } from '@solar/theme-pv/catalogue';
import type { StorefrontExtension } from './types';

export type { StorefrontExtension, ThemeBundle } from './types';

/** Build-time module consumed by STOREFRONT_EXTENSIONS_MODULE. */
export const extensions: StorefrontExtension[] = [
  {
    id: 'solar-pv',
    themes: [{ themeId: THEME_ID, bundle: solarTheme }],
    apiPrefixes: ['solar'],
    // `solar.pv` is what the site descriptor calls this vertical, and it is how the
    // storefront picks this entry's surface for one tenant out of the several the same
    // image serves.
    plugins: ['solar.pv'],
    // The theme's own surface, so `/c/…`, `/p/…` and `/kits/…` are styled like the rest
    // of the shop instead of like the platform. A reference to a client component is all
    // that crosses the boundary here — the server renders it, never calls it, which is the
    // same shape `tradeSkinOverrides` already relies on.
    catalogueSurface: TradeSurface,
    // The shop's own header chrome: a wide search bar in place of the platform's
    // 220px modal-opening pill, and the departments on a band under the lockup. It
    // hangs off `plugins` above like the surface does, so it reaches this vertical's
    // shops and no others — a kitchen shop cannot inherit it however its shell is
    // configured. The components are client references the storefront renders; it
    // never calls them.
    headerChrome: solarHeaderChrome,
    // This shop's own listing card, on `/c/…` and `/search`. The surface above can restyle
    // the platform's grid but cannot add a line to it, and the approved mockup puts four
    // things on the card the platform card has no markup for: the part number, a spec
    // microtable, the datasheet and pence per watt. Selected by the same `plugins` list as
    // the surface and the chrome, so a kitchen shop can never be drawn with it.
    catalogueComponents: { productGrid: SolarListingGrid },
  },
];

export default extensions;
